var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSixthcell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_774)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 59,
    r: 45,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.9998 43.8542C61.0134 43.8542 62.6457 42.2219 62.6457 40.2083C62.6457 38.1948 61.0134 36.5625 58.9998 36.5625C56.9863 36.5625 55.354 38.1948 55.354 40.2083C55.354 42.2219 56.9863 43.8542 58.9998 43.8542Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.146 54.2708V53.2292C50.146 50.9271 52.0106 49.0625 54.3127 49.0625H63.6877C65.9898 49.0625 67.8543 50.9271 67.8543 53.2292V54.2708H50.146Z",
    fill: "#CF91A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5833 73.0208C75.5969 73.0208 77.2292 71.3885 77.2292 69.375C77.2292 67.3614 75.5969 65.7291 73.5833 65.7291C71.5698 65.7291 69.9375 67.3614 69.9375 69.375C69.9375 71.3885 71.5698 73.0208 73.5833 73.0208Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.729 83.4376V82.3959C64.729 80.0938 66.5936 78.2292 68.8957 78.2292H78.2707C80.5728 78.2292 82.4373 80.0938 82.4373 82.3959V83.4376H64.729Z",
    fill: "#CF91A4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4168 73.0208C46.4304 73.0208 48.0627 71.3885 48.0627 69.375C48.0627 67.3614 46.4304 65.7291 44.4168 65.7291C42.4033 65.7291 40.771 67.3614 40.771 69.375C40.771 71.3885 42.4033 73.0208 44.4168 73.0208Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5625 83.4376V82.3959C35.5625 80.0938 37.4271 78.2292 39.7292 78.2292H49.1042C51.4063 78.2292 53.2708 80.0938 53.2708 82.3959V83.4376H35.5625Z",
    fill: "#CF91A4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8958 78.2292H39.7292C37.4271 78.2292 35.5625 80.0938 35.5625 82.3959V83.4376H39.7292V82.3959C39.7292 80.0938 41.5938 78.2292 43.8958 78.2292Z",
    fill: "#9E2349"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0623 78.2292H68.8957C66.5936 78.2292 64.729 80.0938 64.729 82.3959V83.4376H68.8957V82.3959C68.8957 80.0938 70.7602 78.2292 73.0623 78.2292Z",
    fill: "#9E2349"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4793 49.0625H54.3127C52.0106 49.0625 50.146 50.9271 50.146 53.2292V54.2708H54.3127V53.2292C54.3127 50.9271 56.1772 49.0625 58.4793 49.0625Z",
    fill: "#9E2349"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5207 40.2083C59.5207 38.9708 60.1394 37.8813 61.0832 37.2229C60.4915 36.8104 59.7748 36.5625 58.9998 36.5625C56.9873 36.5625 55.354 38.1958 55.354 40.2083C55.354 42.2208 56.9873 43.8542 58.9998 43.8542C59.7748 43.8542 60.4915 43.6083 61.0832 43.1938C60.1394 42.5354 59.5207 41.4458 59.5207 40.2083Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9377 69.375C44.9377 68.1375 45.5564 67.0479 46.5002 66.3895C45.9085 65.977 45.1918 65.7291 44.4168 65.7291C42.4043 65.7291 40.771 67.3625 40.771 69.375C40.771 71.3875 42.4043 73.0208 44.4168 73.0208C45.1918 73.0208 45.9085 72.775 46.5002 72.3604C45.5564 71.702 44.9377 70.6125 44.9377 69.375Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1042 69.375C74.1042 68.1375 74.7229 67.0479 75.6667 66.3895C75.075 65.977 74.3583 65.7291 73.5833 65.7291C71.5708 65.7291 69.9375 67.3625 69.9375 69.375C69.9375 71.3875 71.5708 73.0208 73.5833 73.0208C74.3583 73.0208 75.075 72.775 75.6667 72.3604C74.7229 71.702 74.1042 70.6125 74.1042 69.375Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9998 45.4167C56.129 45.4167 53.7915 43.0792 53.7915 40.2083C53.7915 37.3375 56.129 35 58.9998 35C61.8707 35 64.2082 37.3375 64.2082 40.2083C64.2082 43.0792 61.8707 45.4167 58.9998 45.4167ZM58.9998 38.125C57.8519 38.125 56.9165 39.0604 56.9165 40.2083C56.9165 41.3563 57.8519 42.2917 58.9998 42.2917C60.1478 42.2917 61.0832 41.3563 61.0832 40.2083C61.0832 39.0604 60.1478 38.125 58.9998 38.125Z",
    fill: "#2F3130"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4168 54.271H66.2918V53.2293C66.2918 51.7939 65.1231 50.6251 63.6877 50.6251H54.3127C52.8772 50.6251 51.7085 51.7939 51.7085 53.2293V54.271H48.5835V53.2293C48.5835 50.0689 51.1522 47.5001 54.3127 47.5001H63.6877C66.8481 47.5001 69.4168 50.0689 69.4168 53.2293V54.271Z",
    fill: "#2F3130"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5833 74.5834C70.7125 74.5834 68.375 72.2459 68.375 69.3751C68.375 66.5042 70.7125 64.1667 73.5833 64.1667C76.4542 64.1667 78.7917 66.5042 78.7917 69.3751C78.7917 72.2459 76.4542 74.5834 73.5833 74.5834ZM73.5833 67.2917C72.4354 67.2917 71.5 68.2272 71.5 69.3751C71.5 70.523 72.4354 71.4584 73.5833 71.4584C74.7313 71.4584 75.6667 70.523 75.6667 69.3751C75.6667 68.2272 74.7313 67.2917 73.5833 67.2917Z",
    fill: "#2F3130"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9998 83.4375H80.8748V82.3958C80.8748 80.9604 79.7061 79.7916 78.2707 79.7916H68.8957C67.4603 79.7916 66.2915 80.9604 66.2915 82.3958V83.4375H63.1665V82.3958C63.1665 79.2354 65.7353 76.6666 68.8957 76.6666H78.2707C81.4311 76.6666 83.9998 79.2354 83.9998 82.3958V83.4375Z",
    fill: "#2F3130"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4168 74.5834C41.546 74.5834 39.2085 72.2459 39.2085 69.3751C39.2085 66.5042 41.546 64.1667 44.4168 64.1667C47.2877 64.1667 49.6252 66.5042 49.6252 69.3751C49.6252 72.2459 47.2877 74.5834 44.4168 74.5834ZM44.4168 67.2917C43.2689 67.2917 42.3335 68.2272 42.3335 69.3751C42.3335 70.523 43.2689 71.4584 44.4168 71.4584C45.5647 71.4584 46.5002 70.523 46.5002 69.3751C46.5002 68.2272 45.5647 67.2917 44.4168 67.2917Z",
    fill: "#2F3130"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8333 83.4375H51.7083V82.3958C51.7083 80.9604 50.5396 79.7916 49.1042 79.7916H39.7292C38.2938 79.7916 37.125 80.9604 37.125 82.3958V83.4375H34V82.3958C34 79.2354 36.5688 76.6666 39.7292 76.6666H49.1042C52.2646 76.6666 54.8333 79.2354 54.8333 82.3958V83.4375Z",
    fill: "#2F3130"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2915 60.0251H38.1665C38.1665 51.9501 42.8998 44.5314 50.2248 41.1251L51.5436 43.9585C45.3144 46.8543 41.2915 53.1605 41.2915 60.0251Z",
    fill: "#2F3130"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8331 60.0251H76.7081C76.7081 53.1605 72.6852 46.8543 66.4581 43.9585L67.7768 41.1251C75.0998 44.5314 79.8331 51.9501 79.8331 60.0251V60.0251Z",
    fill: "#2F3130"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M59 80.8583C58.2625 80.8583 57.5375 80.8188 56.8208 80.7458L57.1458 77.6375C58.402 77.7688 59.7145 77.7604 60.9729 77.625L61.3145 80.7313C60.5562 80.8146 59.7833 80.8583 59 80.8583Z",
    fill: "#2F3130"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_774",
    x: 0,
    y: 0,
    width: 130,
    height: 130,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.490196 0 0 0 0 0.34902 0 0 0 0 0.764706 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_774"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_774",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSixthcell);
export default __webpack_public_path__ + "static/media/sixthcell.45729b35ce10f426cd853d26d154ee1f.svg";
export { ForwardRef as ReactComponent };